module.exports = __webpack_public_path__ + "static/img/locations.5624a0b2.png";